import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckIcon,
  Cancel as CancelIcon,
  Schedule as PendingIcon,
  Warning as WarningIcon,
  Info as InfoIcon
} from '@mui/icons-material';

const statusConfig = {
  confirmed: {
    color: 'success',
    icon: CheckIcon,
    label: 'Confirmed'
  },
  pending: {
    color: 'warning',
    icon: PendingIcon,
    label: 'Pending'
  },
  cancelled: {
    color: 'error',
    icon: CancelIcon,
    label: 'Cancelled'
  },
  active: {
    color: 'success',
    icon: CheckIcon,
    label: 'Active'
  },
  inactive: {
    color: 'default',
    icon: InfoIcon,
    label: 'Inactive'
  },
  completed: {
    color: 'success',
    icon: CheckIcon,
    label: 'Completed'
  },
  processing: {
    color: 'info',
    icon: PendingIcon,
    label: 'Processing'
  },
  failed: {
    color: 'error',
    icon: WarningIcon,
    label: 'Failed'
  }
};

function StatusChip({ 
  status, 
  size = 'small', 
  variant = 'filled',
  showIcon = true,
  customLabel,
  sx = {}
}) {
  const config = statusConfig[status?.toLowerCase()] || statusConfig.pending;
  const Icon = config.icon;
  const label = customLabel || config.label;

  return (
    <Chip
      label={label}
      color={config.color}
      size={size}
      variant={variant}
      icon={showIcon ? <Icon sx={{ fontSize: '16px !important' }} /> : undefined}
      sx={{
        fontWeight: 500,
        ...sx
      }}
    />
  );
}

export default StatusChip;